//container of state
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import userReducer from "./reducers/userReducer";
import uiReducer from "./reducers/uiReducer";

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const saveToLocalStorage = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (err) {
    console.error(err);
  }
};

const peristedState = loadFromLocalStorage();

const middleware = [thunk];

const reducers = combineReducers({
  user: userReducer,
  ui: uiReducer
});

const store = createStore(
  reducers,
  peristedState,
  compose(applyMiddleware(...middleware))
);

store.subscribe(() => {
  saveToLocalStorage(store.getState());
});

export default store;
